const ESCAPE_MAP: Record<string, string> = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#x27;'
}

const ESCAPE_REGEX = /[&<>"']/g

export function escapeHtml(str: string): string {
  return String(str).replace(ESCAPE_REGEX, char => ESCAPE_MAP[char])
}

export function escapeAttribute(str: string): string {
  return escapeHtml(str)
}
